document.addEventListener('DOMContentLoaded', function() {

  const wrapper = document.querySelector('.js-custom-quiz__steps');
  if (!wrapper) return;

  let currentStep = 1;
  const track = document.querySelector('.custom-quiz__wrapper-track');
  const data = {};

  // Follow-up containers
  const mhYesContainer = document.querySelector('.js-mounting-holes--yes');
  const mhNoContainer = document.querySelector('.js-mounting-holes--no');

  // ==========================================
  // PROGRESS BAR CONTROLLER
  // ==========================================
  function updateProgressBar(step) {
    const progressSteps = document.querySelectorAll('.js-progress-step');
    const progressFill = document.querySelector('.js-progress-fill');

    if (!progressSteps.length || !progressFill) return;

    let fillPercentage = 0;
    if (step === 2) fillPercentage = 50;
    if (step >= 3) fillPercentage = 100;
    progressFill.style.width = `${fillPercentage}%`;

    progressSteps.forEach((circle, index) => {
      const circleStepNumber = index + 1;
      if (circleStepNumber <= step) {
        circle.classList.add('is-active');
      } else {
        circle.classList.remove('is-active');
      }
    });
  }

  updateProgressBar(1);

  // ==========================================
  // NAVIGATION & COLLECTION
  // ==========================================
  function showStep(step) {
    const offset = (step - 1) * -100;
    if (track) track.style.transform = `translateX(${offset}%)`;
    updateProgressBar(step);
    step1El.classList.remove('active');
    step2El.classList.remove('active');
    document.querySelector(`.custom-quiz__step[data-step="${step}"]`).classList.add('active');
  }

  function collectStep1() {
    data.measurementType = wrapper.querySelector('#Option-custom-quiz--measurement-type')?.checked
      ? 'Duct Size'
      : 'Vent Size';

    // CAPTURE NEW INSTALLATION LOCATION
    // data.whereIsInstall = wrapper.querySelector('input[name="installation_location"]:checked')?.value || 'Floor';

    data.applications = wrapper.querySelector('#Option-custom-quiz--applications')?.value || '';

    data.width = wrapper.querySelector('#width')?.value || '';
    data.length = wrapper.querySelector('#length')?.value || '';
    data.qty = wrapper.querySelector('#Option-custom-quiz--quantity')?.value || '1';
    data.additionalComments = wrapper.querySelector('#Option-custom-quiz--additional-comments')?.value || '';
  }

  function collectStep2() {
    data.style = wrapper.querySelector('input[name="style"]:checked')?.value || '';
    data.color = wrapper.querySelector('input[name="color"]:checked')?.value || '';
  }

  // ==========================================
  // SUMMARY & HIDDEN INPUTS
  // ==========================================
  function renderSummary() {
    const summaryWrapper = document.querySelector('.js-custom-quiz-summary-wrapper');
    if (!summaryWrapper) return;

    const selectedStyle = document.querySelector('input[name="style"]:checked');
    const selectedColor = document.querySelector('input[name="color"]:checked');

    let styleHTML = '';
    let colorHTML = '';

    if (selectedStyle) {
      const styleLabel = selectedStyle.closest('label');
      const styleImg = styleLabel.querySelector('img')?.src || '';
      const styleTitle = styleLabel.querySelector('.quiz-choice-title')?.textContent || data.style;

      styleHTML = `
        <div class="custom-quiz-summary-item">
          <p class="summary-label utility utility--testimonial"><span>Style:</span></p>
          <div class="summary-choice">
            <p class="summary-label utility utility--testimonial">${styleTitle}</p>
            ${styleImg ? `<img src="${styleImg}" alt="${styleTitle}" class="summary-img">` : ''}
          </div>
        </div>
      `;
    }

    if (selectedColor) {
      const colorLabel = selectedColor.closest('label');
      const colorImg = colorLabel.querySelector('img')?.src || '';
      const colorTitle = colorLabel.querySelector('.quiz-choice-title')?.textContent || data.color;

      colorHTML = `
        <div class="custom-quiz-summary-item">
          <p class="summary-label utility utility--testimonial"><span>Powder Coat Finish:</span></p>
          <div class="summary-choice">
            <p class="summary-label utility utility--testimonial">${colorTitle}</p>
            ${colorImg ? `<img src="${colorImg}" alt="${colorTitle}" class="summary-img">` : ''}
          </div>
        </div>
      `;
    }

    summaryWrapper.innerHTML = `
      ${styleHTML}
      ${colorHTML}
      <div class="custom-quiz-summary-item">
        <p class="summary-label utility utility--testimonial">
          <span>Measurement Type:</span> ${data.measurementType || 'Duct size'}
        </p>
      </div>
      <div class="custom-quiz-summary-item">
        <p class="summary-label utility utility--testimonial">
          <span>Applications:</span> ${data.applications || 'None selected'}
        </p>
      </div>
      <div class="custom-quiz-summary-item">
        <p class="summary-label utility utility--testimonial">
          <span>Width:</span> ${data.width} inches
        </p>
      </div>
      <div class="custom-quiz-summary-item">
        <p class="summary-label utility utility--testimonial">
          <span>Length:</span> ${data.length} inches
        </p>
      </div>
      <div class="custom-quiz-summary-item">
        <p class="summary-label utility utility--testimonial">
          <span>Quantity:</span> ${data.qty}
        </p>
      </div>
    `;
  }

  function fillHiddenInputs() {
    const styleInput = document.querySelector('#hidden-style');
    const colorInput = document.querySelector('#hidden-color');
    const measurementTypeInput = document.querySelector('#hidden-measurement-type');
    // const installInput = document.querySelector('#hidden-where-install');
    const applicationsInput = document.querySelector('#hidden-applications');
    const widthInput = document.querySelector('#hidden-width');
    const lengthInput = document.querySelector('#hidden-length');
    const qtyInput = document.querySelector('#hidden-qty');
    const additionalCommentsInput = document.querySelector('#hidden-additional-comments');

    if (styleInput) styleInput.value = data.style || '';
    if (colorInput) colorInput.value = data.color || '';
    if (measurementTypeInput) measurementTypeInput.value = data.measurementType || 'Duct size';
    // if (installInput) installInput.value = data.whereIsInstall || 'Floor';
    if (applicationsInput) applicationsInput.value = data.applications || '';
    if (widthInput) widthInput.value = data.width || '';
    if (lengthInput) lengthInput.value = data.length || '';
    if (qtyInput) qtyInput.value = data.qty || '1';
    if (additionalCommentsInput) additionalCommentsInput.value = data.additionalComments || '';
  }

  // ==========================================
  // DIRECT LIVE VALIDATION FOR STEP 1
  // ==========================================
  const step1El = document.querySelector('.custom-quiz__step[data-step="1"]');
  if (step1El) {
    const nextBtn1 = step1El.querySelector('.js-quiz-next');
    const widthInput = step1El.querySelector('#width');
    const lengthInput = step1El.querySelector('#length');
    const appSelect = step1El.querySelector('#Option-custom-quiz--applications');

    function checkStep1Live() {
      if (!nextBtn1) return;

      const widthVal = widthInput ? widthInput.value.trim() : '';
      const lengthVal = lengthInput ? lengthInput.value.trim() : '';
      const appVal = appSelect ? appSelect.value.trim() : '';

      let isValid = widthVal !== '' && lengthVal !== '' && parseFloat(widthVal) > 0 && parseFloat(lengthVal) > 0 && appVal !== '';;

      if (isValid) {
        nextBtn1.disabled = false;
        nextBtn1.classList.remove('is-disabled');
      } else {
        nextBtn1.disabled = true;
        nextBtn1.classList.add('is-disabled');
      }
    }

    if (widthInput) {
      widthInput.addEventListener('input', checkStep1Live);
      widthInput.addEventListener('change', checkStep1Live);
    }
    if (lengthInput) {
      lengthInput.addEventListener('input', checkStep1Live);
      lengthInput.addEventListener('change', checkStep1Live);
    }
    if (appSelect) {
      appSelect.addEventListener('change', checkStep1Live);
    }

    checkStep1Live();
  }

  // Live validation for Step 2
  const step2El = document.querySelector('.custom-quiz__step[data-step="2"]');
  if (step2El) {
    const nextBtn2 = step2El.querySelector('.js-quiz-next');
    const styleInputs = step2El.querySelectorAll('input[name="style"]');
    const colorInputs = step2El.querySelectorAll('input[name="color"]');

    function checkStep2Live() {
      if (!nextBtn2) return;
      const styleSelected = step2El.querySelector('input[name="style"]:checked');
      const colorSelected = step2El.querySelector('input[name="color"]:checked');

      if (styleSelected && colorSelected) {
        nextBtn2.disabled = false;
        nextBtn2.classList.remove('is-disabled');
      } else {
        nextBtn2.disabled = true;
        nextBtn2.classList.add('is-disabled');
      }
    }

    styleInputs.forEach(input => input.addEventListener('change', checkStep2Live));
    colorInputs.forEach(input => input.addEventListener('change', checkStep2Live));
    checkStep2Live();
  }


  const installRadios = document.querySelectorAll('input[name="installation_location"]');
  const installHidden = document.querySelector('#hidden-where-install');
  installRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      if (installHidden) installHidden.value = this.value;
    });
  });

  wrapper.addEventListener('click', function(e) {
    // Check if the clicked target is the next button
    if (e.target.classList.contains('js-quiz-next')) {
      // SAFEGUARD: Do nothing if the button is disabled
      if (e.target.disabled || e.target.classList.contains('is-disabled')) {
        return; 
      }

      scrollToQuizTop();

      if (currentStep === 1) {
        collectStep1();
        currentStep++;
        showStep(currentStep);
        return;
      }

      if (currentStep === 2) {
        collectStep2();
        goToSummary();
        return;
      }
    }

    if (e.target.classList.contains('js-quiz-prev')) {
      currentStep--;
      showStep(currentStep);
    }
  });

  const quizWrapper = document.querySelector('.custom-quiz__wrapper');
  const summaryWrapperContainer = document.querySelector('.custom-quiz__summary-wrapper');
  const contactWrapper = document.querySelector('.contact-form-custom__wrapper');

  function goToSummary() {
    renderSummary();
    if (quizWrapper) quizWrapper.classList.remove('is-active');
    setTimeout(() => {
      if (summaryWrapperContainer) summaryWrapperContainer.classList.add('is-active');
      updateProgressBar(3);
    }, 200);
  }

  function backFromSummary() {
    if (summaryWrapperContainer) summaryWrapperContainer.classList.remove('is-active');
    setTimeout(() => {
      if (quizWrapper) quizWrapper.classList.add('is-active');
      currentStep = 2;
      showStep(currentStep);
      scrollToQuizTop();
    }, 200);
  }

  function goToContact() {
    collectStep2();
    fillHiddenInputs();
    if (summaryWrapperContainer) summaryWrapperContainer.classList.remove('is-active');
    setTimeout(() => {
      if (contactWrapper) contactWrapper.classList.add('is-active');
      updateProgressBar(3);
    }, 200);
  }

  function scrollToQuizTop() {
    const wrapperTop = wrapper.getBoundingClientRect().top + window.scrollY;

    // Scroll to the position minus the header height and padding
    window.scrollTo({
      top: wrapperTop - 94,
      behavior: 'smooth'
    });
  }

  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('js-summary-submit')) {
      goToContact();
    }

    // NEW: Trigger back navigation when clicking the summary back button
    if (e.target.classList.contains('js-summary-back')) {
      backFromSummary();
    }
  });
});

document.addEventListener('keydown', (e) => {
  if (e.target.matches('input[type="number"]')) {
    // Allow: backspace, delete, tab, escape, enter, arrows, and digits
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
    if (allowedKeys.includes(e.key)) return;

    // Allow Ctrl/Cmd combos (copy, paste, select all, etc.)
    if (e.ctrlKey || e.metaKey) return;

    // Block anything that isn't a digit 0-9
    if (!/^[0-9]$/.test(e.key)) {
      e.preventDefault();
    }
  }
});

// Also catch paste events (keydown won't stop pasted text)
document.addEventListener('input', (e) => {
  if (e.target.matches('input[type="number"]')) {
    const cleaned = e.target.value.replace(/[^0-9]/g, '');
    if (e.target.value !== cleaned) {
      e.target.value = cleaned;
    }
  }
});

class QuizApplicationDescription {
  constructor(select) {
    this.select = select;
    this.wrapper = select.closest('.select-wrapper');
    this.output = this.wrapper.querySelector('[data-application-description]');
    const mapEl = this.wrapper.querySelector('[data-application-descriptions]');

    if (!this.output || !mapEl) return;

    this.map = JSON.parse(mapEl.textContent);
    this.select.addEventListener('change', () => this.update());
  }

  update() {
    const text = this.map[this.select.value];
    this.output.textContent = text ?? '';
    this.output.hidden = !text;
  }
}

const applicationSelect = document.getElementById('Option-custom-quiz--applications');
if (applicationSelect) new QuizApplicationDescription(applicationSelect);